import { Component, OnInit } from '@angular/core';
import { NaviService } from '../../services/navi.service';
import { HCPStatisticService } from '../../services/hcpstatistic.service';
import { BasicError } from '../../models/error/error';

import { ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';

import { Study } from '../../models/study';
import { HCPGroupService } from '../../services/hcpgroup.service';
import { GroupService } from '../../services/group.service';

@Component({
  selector: 'app-group-details',
  templateUrl: './group-details.component.html',
  styleUrls: ['./group-details.component.css']
})
export class GroupDetailsComponent implements OnInit {
  public amountCollaborators: Number = 0;
  public amountMembers: Number = 0;
  public amountAnswersheets: Number = 0;
  private studyId: any;
  public currentStudy: Study;
  public title: String = '';
  public desc: String = '';
  public loaded = false;

  public passwordInput = '';
  public passwordInputClass = 'setPassword-Input';
  public mode = null;
  public currentPrivate = 0;
  public state = '';

  constructor(private naviService: NaviService, private statistics: HCPStatisticService,
    private route: ActivatedRoute, private location: Location, private hcpGroup: HCPGroupService, private groupService: GroupService) {
    this.currentStudy = new Study('0');
  }

  ngOnInit() {
    this.route.paramMap.switchMap((params: ParamMap) => {
      this.studyId = params.get('id');
      return this.groupService.getGroupDetail(params.get('id'))
    }).subscribe(dd => {
      if (dd instanceof BasicError) {
        console.log('Error occured while reading study');
      } else if (dd instanceof Study) {
        this.currentStudy = dd;
        this.title = this.currentStudy.getTitle();
        this.desc = this.currentStudy.getDescription();
        this.loaded = true;

        if (this.currentStudy.getIs_private() && this.currentStudy.getAccesstype() === 'invite') {
          this.mode = 'invite';
        } else if (this.currentStudy.getIs_private()) {
          this.mode = 'password';
        } else {
          this.mode = 'public';
        }

        this.currentPrivate = this.currentStudy.getIs_private();

        // Getting Data of study
        this.statistics.getAmountCollaborators(this.studyId.toString()).subscribe(data => {
          if (!(data instanceof BasicError)) {
            this.amountCollaborators = data.count;
          }
        });

        this.statistics.getAmountMembers(this.studyId.toString()).subscribe(data => {
          if (!(data instanceof BasicError)) {
            this.amountMembers = data;
          }
        });
      }
    });
  }

  /**
   * Setting mode of study to this
   * @param is_private if it is private or public
   * @param accesstype which accesstype should be used
   */
  public setModePublicInvite(is_private, accesstype, un) {
    if (is_private && accesstype === null) {
      return; // accesstype shouldn't be null
    }

    if (is_private && accesstype === 'password' && this.passwordInput === '') {
      return; // password must be given
    }

    const tmp = this.mode;

    if (!is_private) {
      this.mode = 'public';
    } else if (accesstype === 'invite') {
      this.mode = 'invite';
    } else {
      this.mode = 'password';
    }

    this.state = 'loading';

    this.hcpGroup.setStudyMode(this.currentStudy, is_private, accesstype, this.passwordInput).subscribe(data => {
      if (data) {
        // Successful
        this.state = '';

        if (is_private) {
          this.currentPrivate = 1;
        } else {
          this.currentPrivate = null;
        }
      } else {
        // failed
        this.state = '';
        this.mode = tmp;
      }

      this.showPasswordInput(false);
    });
  }

  /**
   * Showing or hiding password input mask
   * @param show showing or hiding
   */
  public showPasswordInput(show: Boolean = true) {
    if (show) {
      this.passwordInputClass = 'showInput';
    } else {
      this.passwordInputClass = '';
    }
  }


}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/group-details/group-details.component.ts